import React from "react";

const LinkIcon = props => (
  <svg width={10} height={11} viewBox="0 0 10 11" {...props}>
    <defs>
      <linearGradient id="a" x1="-15.842%" x2="109.964%" y1="13.157%" y2="116.349%">
        <stop offset="0%" stopColor="#00B1FF" />
        <stop offset="72.016%" stopColor="#0060E7" />
        <stop offset="100%" stopColor="#0046DF" />
        <stop offset="100%" stopColor="#D3E1EF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-505 -706)">
      <path fill="url(#a)" d="M0 85h1439v635H0z" />
      <rect width={730} height={1584} x={65} y={458} fill="currentColor" rx={5} />
      <g transform="translate(387 695)">
        <rect width={258} height={32} fill="#212121" rx={4} />
        <path
          fill="currentColor"
          d="M123.514 22h-1.627l.993-2.804h-1.627L120.277 22h-1.61l.977-2.804H118l.445-1.335h1.678l.925-2.722h-1.661l.428-1.319h1.712l.96-2.82h1.609l-.959 2.82h1.61l.958-2.82h1.627l-.993 2.82H128l-.394 1.32h-1.73l-.941 2.72h1.73l-.429 1.336h-1.763l-.96 2.804zm-.189-4.14l.942-2.72h-1.61l-.924 2.72h1.592z"
        />
      </g>
    </g>
  </svg>
);

export default LinkIcon;
